import React from 'react';
import { Chip } from '@mui/material';
import DashboardToolbarPortal from './DashboardToolbarPortal';
import { loadedFactorSliceLabel, loadedWorkspaceFactorState } from '../../../utils/loadedFactorSlice';

export default function DashboardLoadedFactorChip({
    activeView,
    userUid,
    scopeKey,
    loadedRiskContext,
    riskResultLoaded = false,
    posSizingWorkspace,
    posSizingLoading = false,
    optimizerFactorContext,
    optimizerResultLoaded = false,
}) {
    if (!['overview', 'watchlist', 'pos-sizing', 'optimizer'].includes(activeView)) return null;
    const workspace = activeView === 'pos-sizing'
        ? loadedWorkspaceFactorState(posSizingWorkspace, userUid, scopeKey)
        : null;
    const context = workspace ? workspace.context : activeView === 'optimizer'
        ? (optimizerResultLoaded ? optimizerFactorContext : null)
        : (riskResultLoaded ? loadedRiskContext : null);
    const resultLoaded = workspace ? workspace.resultLoaded : activeView === 'optimizer'
        ? optimizerResultLoaded : riskResultLoaded;
    return <DashboardToolbarPortal order={1}>
        <Chip size="small" variant="outlined" aria-label="Loaded factor data"
            sx={{ maxWidth: '100%', fontSize: 11 }}
            label={activeView === 'pos-sizing' && posSizingLoading && !resultLoaded
                ? 'Loading factor data…' : loadedFactorSliceLabel(context, resultLoaded)} />
    </DashboardToolbarPortal>;
}
